import { createBaseQuery } from "../helper/createBaseQuery";
import { tokenSlice } from "../slice/tokenSlice";


const logInformationApi = tokenSlice.injectEndpoints({
    reducerPath: 'logInformation',
    baseQuery: createBaseQuery(),
    endpoints(builder) {
        return {
            addLogInformation: builder.mutation({
                query: (logInformation) => ({
                    url: 'LogInformation/GetAllLogInformations',
                    method: 'POST',
                    body: logInformation
                }),
                invalidatesTags: ['LogInformation']
            })
        }
    }
})

export const { useAddLogInformationMutation } = logInformationApi
export { logInformationApi }